import React from "react";
import JobPost from "../../components/JobPost/JobPost";
import Topbar from "../../components/Recruiter/Topbar/Topbar";
const NewJobPost = () => {
  return (
    <div className="radial-gradient-bg">
      <Topbar />
      <JobPost />
    </div>
  );
};
export default NewJobPost;
